<script setup lang="ts">
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'

const emptyResponse = inject('emptyResponse')
const readOnlyResetKey = inject<string | number | undefined>('readOnlyResetKey')
const { t } = useI18n()
// const userSession = useUserSession()
// const subjektId = userSession?.user?.subjekt?.subjektId
// const getApi = new apisPortal.SubjektyApi()
// const { remove, push, fields } = useFieldArray('ziadatel.kontaktneOsoby')

// TODO: zaital na BE nie je moznost pridavania kontaktnej osoby pre FO
// const osobySubjektuAutocomplete = computed(() =>
//   res.map(
//     // subjektyOrganizacie.value.map(
//     (osoba) =>
//       ({
//         osobaId: osoba.osobaRef.osobaId,
//         menoUplne: osoba.osobaRef.menoUplne,
//       } || [])
//   )
// )

// const getOsoba = (osobaId: string) => {
//   const osobaKontext = res.find((osoba) => osoba.osobaRef?.osobaId === osobaId)

//   return {
//     osobaRef: osobaKontext?.osobaRef,
//     kontakt: osobaKontext?.osoba.primarnyKontakt,
//   }
// }
</script>

<template>
  <div v-if="emptyResponse.ziadatel.kontaktneOsoby">
    <!-- TODO: zaital na BE nie je moznost pridavania kontaktnej osoby pre FO -->
    <!-- <div class="idsk-crossroad-line mb-8 mt-8"></div>

    <IDSKHeading as="h2" variant="l">
      {{ t('zoppm.step7.fyzickaOsoba.kontaktnaOsobaHeading') }}
    </IDSKHeading>
    <IDSKParagraph>
      {{ t('zoppm.step7.fyzickaOsoba.kontaktnaOsobaDescription') }}
    </IDSKParagraph>

    <div v-for="(field, idx) in fields" :key="field.key" class="mb-5">
      <IDSKParagraph class="mb-1">
        {{ field.value.osobaRef.menoUplne }}
      </IDSKParagraph>
      <IDSKParagraph class="mb-1">
        {{ field.value.kontakt.telefonneCislo }}
      </IDSKParagraph>
      <IDSKParagraph class="mb-1">
        {{ field.value.kontakt.email }}
      </IDSKParagraph>

      <IDSKLink
        class="mb-6"
        href="#"
        no-visited-state
        @click.prevent="() => remove(idx)"
      >
        {{ t('zoppm.step7.fyzickaOsoba.odobratKontaktnaOsoba') }}
      </IDSKLink>
    </div>

    <IDSKAutocomplete
      id="kontaktna-osoba-autocomplete-fo"
      :placeholder="t('zoppm.step7.fyzickaOsoba.kontaktnaOsobaHint')"
      :label="t('zoppm.step7.fyzickaOsoba.vyhladajteUdajeZProfilu')"
      :options="osobySubjektuAutocomplete"
      option-object-value="osobaId"
      option-object-label="menoUplne"
      @update:model-value="(osoba: any) => {
          push(getOsoba(osoba.osobaId))
          return osoba
        }"
    /> -->

    <template v-if="isReadOnly">
      <div
        v-for="kontaktnaOsoba in emptyResponse.ziadatel.kontaktneOsoby"
        :key="kontaktnaOsoba"
      >
        <IDSKParagraph class="mb-1">
          {{ kontaktnaOsoba.osobaRef.menoUplne }}
        </IDSKParagraph>
        <IDSKParagraph class="mb-1">
          {{ kontaktnaOsoba.kontakt.telefonneCislo }}
        </IDSKParagraph>
        <IDSKParagraph class="mb-4">
          {{ kontaktnaOsoba.kontakt.email }}
        </IDSKParagraph>

        <IDSKLink class="mb-6" href="javascript:void(0)" no-visited-state>
          {{ t('zoppm.step7.pravnickaOsoba.odobratKontaktnaOsoba') }}
        </IDSKLink>
      </div>

      <div class="autocomplete--with-button">
        <IDSKAutocomplete
          id="kontaktna-osoba-autocomplete-po-ro"
          :key="readOnlyResetKey"
          :placeholder="t('zoppm.step7.pravnickaOsoba.kontaktnaOsobaHint')"
          :label="t('zoppm.step7.pravnickaOsoba.vyhladajteUdajeZProfilu')"
          :options="[]"
        />
        <IDSKButton
          variant="secondary"
          :data-test-id="`zoppm-ziadatel-fo-kontaktna-osoba-pridat`"
        >
          {{ t('globalne.pridat') }}
        </IDSKButton>
      </div>
    </template>
  </div>
</template>

<style lang="scss"></style>
